import { render, staticRenderFns } from "./ReceiptTypeForm.vue?vue&type=template&id=54d0dfee&scoped=true"
import script from "./ReceiptTypeForm.vue?vue&type=script&lang=js"
export * from "./ReceiptTypeForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiptTypeForm.vue?vue&type=style&index=0&id=54d0dfee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0dfee",
  null
  
)

export default component.exports